import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import './assets/styles/tailwind.css'
import './assets/styles/personalCoding.css'

const app = createApp(App)
app.use(router)
app.use(i18n)
app.config.errorHandler = (err, instance, info) => {
  console.error('[vue]', info, err?.message || err, err?.stack)
}
app.mount('#app')
